import { render, staticRenderFns } from "./block-lockdown.vue?vue&type=template&id=082deb20&scoped=true&"
import script from "./block-lockdown.vue?vue&type=script&lang=js&"
export * from "./block-lockdown.vue?vue&type=script&lang=js&"
import style0 from "./block-lockdown.vue?vue&type=style&index=0&id=082deb20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082deb20",
  null
  
)

export default component.exports